import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    ${common.h1};
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: ${colors.pureWhite};
    z-index: 2;
  }

  .container :global(.arrow) {
    margin-left: 1rem;
    width: 2rem;
    height: 2rem;
  }

  .container :global(.arrow img) {
    width: 100%;
    height: 100%;
  }

  .normal {
    // white-space: pre;
    z-index: 1;
    margin: 0;
  }

  .opener {
    position: relative;
  }

  .alt {
    position: relative;
    color: ${colors.governorBayBlue};
    white-space: pre;
    z-index: 1;
  }

  .alt .light {
    z-index: -1;
    position: absolute;
    bottom: 2%;
    left: -1%;
    right: -1%;
    height: 23%;
    background-color: ${colors.yellow};
  }

  .container :global(.current) {
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${colors.governorBayBlue};
  }

  .alt-list {
    position: absolute;
    z-index: 1;
    top: 100%;
    opacity: 0;
    visibility: hidden;
    right: 1.3rem;
    background: white;
    border-radius: 0.4rem;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
    transition: all 150ms ease;
    transform: translateY(-10%);
  }

  .alt-list :global(.alt-link) {
    cursor: pointer;
    color: ${colors.governorBayBlue};
    text-decoration: none;
    padding: 1rem 1.5rem;
  }

  // Keeps the two following rules the same because IE11 does not understand focus-within
  // and invalidates the whole CSS block
  .opener:hover .alt-list,
  .opener :global(.current):focus .alt-list,
  .opener :global(.current)[keyboard-focus] ~ .alt-list {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }

  .alt-list:focus-within {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }

  .alt-list .label {
    transition: all 150ms ease;
  }

  .alt-list :global(.alt-link):hover .label,
  .alt-list :global(.alt-link)[keyboard-focus] .label {
    opacity: 0.6;
  }

  .alt-list :global(.alt-link):active .label {
    opacity: 0.4;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      font-size: 13rem;
    }
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .container {
      font-size: 5rem;
    }
  }
`
